<template>
  <focus-lock>
    <el-dialog
      ref="closedAccountDialog"
      v-loading.fullscreen.lock="mainLoader"
      :show-close="false"
      :visible.sync="dialogVisible"
      custom-class="closed-account-dialog"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      title="Are you sure? We’ll store your data for 30 days, during which time you can change your mind. After 30 days we‘ll permanently delete your data and we won’t be able to recover it for you."
      @opened="dialogOpen('closedAccountDialog')"
      @close="onClose($event)"
    >
      <div class="body">
        <svg-danger-exclamation />
        <h1>Close account</h1>
        <p>We’ll store your data for 30 days, during which time you can change your mind. After 30 days we‘ll permanently delete your data and we won’t be able to recover it for you.</p>
        <div v-if="organisation && organisation.members_count == 1">
          <p class="my-3 font-weight-bolder">
            Warning - Deleting your account will also delete your organisation’s profile from the system.
          </p>
          <p>
            If you don't want to delete your organisation's profile, invite a colleague to join you on the Community Wealth Builder and then choose to delete your account again when you can pass over ownership.
          </p>
        </div>
        <div v-else>
          <p class="my-3">Before you can delete/suspend your account, you must nominate a new owner of your organisation.</p>
        </div>
        <div class="button-wrap d-flex ">
          <el-button
            @click="onClose($event)"
          >
            Go, back
          </el-button>
          <el-button
            v-if="organisation && organisation?.owner.id == user.id && organisation.members_count > 1"
            type="primary"
            :loading="mainLoader"
            @click.prevent="$emit('nominate-new-owner')"
          >
            Nominate new owner
          </el-button>
          <el-button
            v-else
            type="primary"
            :loading="mainLoader"
            @click.prevent="closeAccount()"
          >
            Yes, close my account
          </el-button>
        </div>
      </div>
    </el-dialog>
  </focus-lock>
</template>

<script>
import store from '@/store'
import gsApi from '@/services/gs.api'
import svgDangerExclamation from '@/components/assets/svg-danger-exclamation'

export default {

  components: {
    svgDangerExclamation,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    organisation:{
      type: Object,
      default: null
    },
    user : {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      mainLoader: false,
      dialogVisible: false,
      organisationMembers:[]
    }
  },

  watch: {
    visible(value) {
      this.dialogVisible = this.visible
    }
  },

  created() {
    this.dialogVisible = this.visible
  },

  methods : {
    onClose(e) {
      this.dialogVisible = false
      this.$emit('closed')
    },

    closeAccount() {
      this.mainLoader = true
      gsApi.auth.markAsClosed()
        .then(() => {
          store.commit('USER_LOGOUT')
          this.$router.push('/login')
        }).catch(() => {
          this.$alert(
            '',
            `Unfortunately we're having problems contacting our service. Please try again later.`,
            {
              confirmButtonText: 'Close',
              showClose: false,
              customClass: 'notification-modal'
            }
          )
        }).finally(()=>{
          this.mainLoader = false
        })
    }
  }
}
</script>
